// 模块名称
// export const SWAP = 'swap' // USDT本位永续合约
export const SWAPV2 = 'swapV2' // USDT本位永续合约V2
export const CSWAP = 'cswap' // USDT本位永续合约V2
export const SPOT = 'spot' // 现货
export const STANDARD = 'standard' // 标准现货
export const COMMON = 'common' // 账户与钱包
export const COPYTRADE = 'copyTrade' // 账户与钱包
export const AGENT = 'agent' // 账户与钱包

export const moduleKeys = [SWAPV2,CSWAP, SPOT, STANDARD, COMMON,COPYTRADE,AGENT]


// WEBPACK FOOTER //
// ./src/config/modules.js